module.exports = __webpack_public_path__ + "static/media/PositiveSelfTalkGREEK.99d221b2.vtt";